module.exports = __webpack_public_path__ + "img/other libraries.774bec96.png";